// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/DeviceView/styles.scss
// module id = 1001
// module chunks = 0